import { useFlexLayout, useTable } from 'react-table';
import { Text, Flex, Box } from '@chakra-ui/react';
import { useMemo } from 'react';
import { ProfileLink } from '@/ui/ProfileLink';
import { Table } from './table';
import { UserCard } from './user-card';
import { HtmlText } from '@/pages/contacts/details/components/tabs/activities/Activity';
import { useKFlags } from '@/hooks/use-k-flags';
import { CenterSpinner, Table as DrilldownTable } from '@/components/ats';
import { HeaderCell } from '@/components/ats/Table/tableCells';
import { useBottomScrollListener } from 'react-bottom-scroll-listener';

export const ActivitiesTable = ({
  data = [],
  totalCount = 0,
  currentDrillPage = 1,
  handleLoadMore = () => {},
  columnConfig = [],
  isLoadingMore = false,
}) => {
  const { feDrilldown } = useKFlags();
  const scrollRef = useBottomScrollListener(handleLoadMore, {
    offset: 100,
    debounce: 1000,
  });
  const columns = useMemo(() => {
    return [
      {
        Header: <HeaderCell title="Candidate" />,
        accessor: 'contact',
        minWdith: 120,
        Cell: ({ row }) => {
          const contact = row?.original?.contact;
          return (
            <Flex w="100%">
              <UserCard contact={contact} />
              <Box flexShrink={0}>
                <ProfileLink
                  linkedinUrl={contact?.social?.linkedin_url}
                  greenhouseUrl={contact?.ats?.greenhouse_url}
                  githubUrl={contact?.social?.github_url}
                  leverurl={contact?.ats?.lever_url}
                  ashbyUrl={contact?.ats?.ashby_url}
                />
              </Box>
            </Flex>
          );
        },
      },
      {
        Header: <HeaderCell title=" Last activity" textTransform="none" />,
        accessor: 'activity',
        minWdith: 150,
        Cell: ({ row }) => {
          return (
            <Text fontSize="14px" fontWeight="medium" textAlign="left">
              <HtmlText html={row.original?.activity?.event} />
            </Text>
          );
        },
      },
    ];
  }, []);

  const table = useTable(
    {
      columns,
      data: data || [],
    },
    useFlexLayout
  );

  if (feDrilldown) {
    return (
      <Flex flexDir="column" flex={1}>
        <DrilldownTable
          tableRef={scrollRef}
          columns={columnConfig}
          data={data}
          skipPagination={true}
          pagination={{
            total: totalCount,
            count: data?.length,
            limit: 50,
          }}
          paginationLimit={50}
          page={{ number: currentDrillPage }}
          applyPage={handleLoadMore}
          enableLoadMore={false}
          isLoadingMore={isLoadingMore}
          layoutStyles={{
            borderBottomWidth: '0px',
          }}
        />
        {isLoadingMore && data?.length >= 50 && (
          <Flex my="5px" justifyContent="center">
            <CenterSpinner h="50px" />
          </Flex>
        )}
      </Flex>
    );
  }

  return <Table table={table} />;
};
